import {
  FormControl,
  MenuItem,
  Select,
  InputLabel,
  SelectChangeEvent,
} from '@mui/material';
import { LabelWithTooltip } from './LabelWithTooltip';
import { DYNAMIC_OPERATORS } from 'components/DynamicFormField/DynamicFormField';
import { memo } from 'react';

type OperationSelectorProps = {
  operations: { operation: string; label: string }[];
  selectedOperator: string;
  onOperatorChange: (operator: string) => void;
  fieldData: any;
};

export const OperationSelector = memo(
  ({
    operations,
    selectedOperator,
    onOperatorChange,
    fieldData,
  }: OperationSelectorProps) => {
    const handleChange = (event: SelectChangeEvent<string>) => {
      onOperatorChange(event.target.value);
    };

    // Handle dynamic operators
    const currentOperator =
      Array.isArray(fieldData?.value?.items) &&
      fieldData?.value?.items.length === 1 &&
      DYNAMIC_OPERATORS.includes(fieldData?.value?.items[0])
        ? fieldData.value.items[0]
        : selectedOperator;

    return (
      <FormControl
        fullWidth
        margin="normal"
        variant="outlined"
      >
        <InputLabel>
          <LabelWithTooltip label="Operation" />
        </InputLabel>
        <Select
          value={currentOperator}
          onChange={handleChange}
          label={<LabelWithTooltip label="Operation" />}
        >
          {operations.map((op) => (
            <MenuItem
              key={op.operation}
              value={op.operation}
            >
              {op.label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    );
  },
);
OperationSelector.displayName = 'OperationSelector';
